import { Controller } from "@hotwired/stimulus";
import dropin from "braintree-web-drop-in";
import { errorHandlers } from "../mixins/errorHandlers";

export default class extends Controller {
  static values = {
    apiKey: String,
  };

  static targets = ["card", "form", "token", "error", "submit"];

  connect() {
    errorHandlers(this);
    const form = this.formTarget;
    const token = this.tokenTarget;
    const errorField = this.errorTarget;
    const handleError = this.appendSupportAlertMessage;
    const submit = this.submitTarget;

    submit.disabled = true;
    dropin.create({
      authorization: this.apiKeyValue,
      container: this.cardTarget,
      card: {
        cardholderName: {
          required: true
        }
      }
    }, function(err, dropinInstance) {
      if (err) {
        handleError(err, errorField);
        return;
      }

      submit.disabled = false;

      form.addEventListener('submit', function(event) {
        event.preventDefault();

        submit.disabled = true;
        dropinInstance.requestPaymentMethod(function(error, payload) {
          if (error) {
            submit.disabled = false;
            handleError(error, errorField);
            return;
          }

          token.value = payload.nonce;
          form.submit();
        });
      });
    });
  }

  tokenise_cc(_event) {
    // This method is stubbed, because we already have listener for submit action in connect method.
    // During drop-in element creating, we pass callback function, and inside of it we initiate function which will handle sending request to braintree service.
    // Unfortunately it's unreal to handle this scenario by tokenise_cc method,
    // because dropinInstance is available only inside callback function and inside those functions which are initiated inside of it.
  }
}
